import React, { useEffect, useState } from 'react';
import {  useNavigate, } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import colors from '../../Utils/colors';
import CheerioButton from '../../Components/CheerioButton';
import images from '../../Utils/images';
import TicketComponent from './Components/TicketComponent';
import AgentReportModal from './Components/AgentReportModal';
import ResponseComponent from './Components/ResponseComponent';
import { useSelector } from 'react-redux';
import {
  V2AgentGet,
  downloadAllAgentAnalytics,
  downloadSingleAgentAnalytics,
  getAllAgentAnalytics,
  getAllAgentsGraphData,
  getSingleAgentAnalytics,
  getSingleAgentsGraphData,
  getResponsePerfomance,
} from '../../Services';
import SpinnerLoader from '../../Components/SpinnerLoader';
import GraphComponent from './Components/GraphComponent';
import { toast } from 'react-toastify';
import { MailCsvModal } from '../CreatorAnalyticsNew/MailCsvModal';
import { trackPages } from '../../Utils/brevo';

const AgentAnalytics = ({ excepted }) => {
  const authtoken = useSelector((state) => state.main.auth_token);
  const localdata = useSelector((state) => state.main.localdata);
  const agentdata = useSelector((state) => state.main.agentdata);
  const navigate = useNavigate();
  const [timeFrame, setTimeFrame] = useState(168);
  const [agentName, setAgentName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [analyticsData, setAnalyticsData] = useState();
  const [agentList, setAgentList] = useState({});
  const [graphTimeframe, setGraphTimeframe] = useState('1w');
  const [graphData, setGraphData] = useState();
  const [graphIsLoading, setGraphIsLoading] = useState(false);
  const [showMailModal, setShowMailModal] = useState(false);
  const [performanceAgentName, setPerformanceAgentName] = useState('allAgent');
  const [performanceAnalyticsData, setPerformanceAnalyticsData] = useState();
  const [responsePerformance, setResponsePerfomance] = useState();
  const [overViewTimeFrame, setoverviewTimeFrame] = useState(() => {
    return localStorage.getItem('overViewTimeFrame') || 168;
  });
  const [performanceTimeFrame, setPerformanceTimeFrame] = useState(() => {
    return Number(localStorage.getItem('performanceTimeFrame')) || 168;
  });

  const [responsePerformanceTimeFrame, setResponsePerformanceTimeFrame] = useState(() => {
    return Number(localStorage.getItem('responsePerformanceTimeFrame')) || 168;
  });
  const [responsePerformanceAgentName, setresponsePerformanceAgentName] = useState('allAgent')
  const [overviewStatsLoading,setOverviewStatsLoading] = useState(false)
  const [agentPerformanceLoading, setAgentPerformanceLoading] = useState(false)
  const [responsePerformanceLoading, setResponsePerfomanceLoading] = useState(false);
  const [graphAgentName, setgraphAgentName] = useState('allAgent');
  const analyticsTimeframes = [
    { id: 3, label: '3 hr' },
    { id: 9, label: '9 hr' },
    { id: 12, label: '12 hr' },
    { id: 24, label: '24 hr' },
    { id: 168, label: '1 week' },
    { id: 720, label: '1 month' },
    { id: 2160, label: '3 month' },
  ];
  useEffect(() => {
    setIsLoading(true);
    setGraphIsLoading(true);
    getAllAgentAnalyticsAPICall();
    getAgentsAPICall();
    getGraphDataAPICall();
    getResponsePerfomanceAPICall()
    trackPages('analytics_agent_analytics_page', localdata);
  }, []);

  useEffect(() => {
    localStorage.setItem('performanceTimeFrame', performanceTimeFrame);
    getPerformanceAgentAnalytics();
  }, [performanceTimeFrame, performanceAgentName]);

  useEffect(()=>{
    localStorage.setItem('overViewTimeFrame', overViewTimeFrame);
    getAllAgentAnalyticsAPICall()
  },[overViewTimeFrame])

  useEffect(()=>{
    localStorage.setItem('responsePerformanceTimeFrame', responsePerformanceTimeFrame);
    getResponsePerfomanceAPICall();
  },[responsePerformanceTimeFrame, responsePerformanceAgentName])
  useEffect(() => {
  if (agentdata && !agentdata?.permission?.agentAnalytics) {
    toast.error(
      'Feature access denied. Kindly request the owner to grant you permission to access this feature'
    );
    navigate('/creator');
  }
}, []);

const getAllAgentAnalyticsAPICall = () => {
  setOverviewStatsLoading(true);
  const token = authtoken;
  const data = {
    hours: overViewTimeFrame,
  };
  getAllAgentAnalytics(token, data)
    .then((res) => {
      if (res?.flag) {
        setAnalyticsData(res.message); 
        setOverviewStatsLoading(false);
      } else {
        console.error('Error occurred. Please try again later.');
        setOverviewStatsLoading(false); 
      }
    })
    .catch((err) => {
      console.error('API call failed:', err);
        setOverviewStatsLoading(false);
    });
};


   const getResponsePerfomanceAPICall = () => {
    setResponsePerfomanceLoading(true);
    let token = authtoken;
    let data = {
      agent: responsePerformanceAgentName,
      hours: responsePerformanceTimeFrame,
    };
    getResponsePerfomance(token, data).then((res) => {
      if (res?.flag) {
        setResponsePerfomance(res?.message);
        setResponsePerfomanceLoading(false);
      } else {
        setResponsePerfomanceLoading(fasle);
        console.error('error occurred please try again later ');
      }
    })
    .catch((err)=>{
      setResponsePerfomanceLoading(false)
      console.log("Api call false", err)
    })
  };


  const getAgentsAPICall = () => {
    let token = authtoken;
    V2AgentGet(token).then((res) => {
      if (res?.flag) {
        const isObjectWithKeys = (obj) =>
          obj && typeof obj === 'object' && Object.keys(obj).length > 0;
        if (isObjectWithKeys(res?.data)) {
          setAgentList(res?.data);
        } else {
          if (!toast.isActive(1)) {
            toast.error(
              'Please create an agent and assign them conversations to see agent analytics',
              {
                position: 'top-right',
                toastId: 1,
              }
            );
          }
        }
      } else {
        if (!toast.isActive(1)) {
          toast.error(
            'Please create an agent and assign them conversations to see agent analytics',
            {
              position: 'top-right',
              toastId: 1,
            }
          );
        }
      }
    });
  };

  useEffect(() => {
    setGraphIsLoading(true);
    if (graphAgentName === 'allAgent') {
      getGraphDataAPICall();
    } else {
      getAgentGraphDataAPICall();
    }
  }, [graphTimeframe, graphAgentName]);

  const getSingleAgentAnalyticsAPICall = () => {
    let token = authtoken;
    let data = {
      _id: agentName,
      hours: timeFrame,
    };
    getSingleAgentAnalytics(token, data).then((res) => {
      if (res?.flag) {
        setAnalyticsData(res?.message);
      } else {
        toast.error('error occurred please try again later', { position: 'top-right' });
      }
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    });
  };

  const getPerformanceAgentAnalytics = () => {
  setAgentPerformanceLoading(true);
  let token = authtoken;
  let data = {
    agent: performanceAgentName,
    hours: performanceTimeFrame,
  };
  getSingleAgentAnalytics(token, data).then((res) => {
    if (res?.flag) {
      setPerformanceAnalyticsData(res?.message);
      setAgentPerformanceLoading(false);
    } else {
      setAgentPerformanceLoading(false);
      toast.error('Error occurred, please try again later', { position: 'top-right' });
    }
  })
  .catch((err)=>{
    console.error('API call failed:', err);
    setAgentPerformanceLoading(false)
  })
};


  const getGraphDataAPICall = () => {
    let token = authtoken;
    let data = {
      time: graphTimeframe,
    };
    getAllAgentsGraphData(token, data).then((res) => {
      if (res?.flag) {
        setGraphData(res?.message);
      } else {
        console.error('error occurred please try again later 4');
      }
      setTimeout(() => {
        setGraphIsLoading(false);
      }, 500);
    });
  };

  const getAgentGraphDataAPICall = () => {
    let token = authtoken;
    let data = {
      _id: graphAgentName,
      time: graphTimeframe,
    };
    getSingleAgentsGraphData(token, data).then((res) => {
      if (res?.flag) {
        setGraphData(res?.message);
      } else {
        toast.error('error occurred please try again later', { position: 'top-right' });
      }
      setTimeout(() => {
        setGraphIsLoading(false);
      }, 500);
    });
  };

  const downloadAnalyticsAPICall = (email) => {
    let token = authtoken;
    let data = {
      hours: reportDownloadTimeFrame,
      email: email ?? localdata?.email,
    };
      downloadAllAgentAnalytics(token, data).then((res) => {
        if (res?.flag) {
          toast.success('Report sent to the entered email successfully', {
            position: 'top-right',

          });
        } else {
          toast.error('Failed to send report, please try again later', {
            position: 'top-right',

          });
        }
      });
  };

  return (
    <>
      <div className="agent_dashboard_container">
        {showMailModal && (
          <AgentReportModal
            show={showMailModal}
            setShow={setShowMailModal}
          />
        )}
        <div className="agent_dashboard_container__header_row" style={{marginBottom: 16}}>
          <h3>{'Support Dashboard'}</h3>
          <div className="agent_dashboard_container__header_row__right m" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            {!excepted && (agentdata?.permission?.agentAnalyticsReport || !agentdata) && (
              <CheerioButton
                textStyle={{
                  color: colors.black,
                  fontWeight: 600,
                  fontSize: '14px',
                }}
                btnText="Export Report"
                icon={images.FILEEXPORT}
                onclick={() => setShowMailModal(true)}
              />
            )}
          </div>
        </div>
        
            <div
             className="shadow_small"
              style={{
                width: '100%',
                backgroundColor: '#fff',
                borderRadius: '12px',
                padding: '20px',
                marginBottom: '20px',
                marginTop: '8px',
              }}
            >
              {overviewStatsLoading ? (
          <>
            <div
              className="d-flex flex-column justify-content-center align-items-center w-100"
              style={{ flex: 1 }}
            >
              <SpinnerLoader />
            </div>
          </>
        ) : (
          <>
              <div className="agent_dashboard_container__header_row__right" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingInline: '12px', }}>

                <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '6px' }}>
                  Overview
                </h2>
                <div style={{ marginRight: 4, width: 'auto' }}>
                  <Form.Select
                    type="text"
                    placeholder="time"
                    className="btncustom dropdown"
                    style={{ borderRadius: 8, fontSize: 16, fontWeight: 400, color: colors.greys01 }}
                    value={overViewTimeFrame}
                    onChange={(e) => {
                      setoverviewTimeFrame(e.target.value);
                    }}
                  >
                    {analyticsTimeframes.map((item, index) => {
                      return (
                        <option
                          style={{ marginTop: 4, marginBottom: 4, borderRadius: 8,  }}
                          value={item.id}
                          key={item.id}
                        >
                          {item.label}
                        </option>
                      );
                    })}
                  </Form.Select>
                </div>
              </div>
              <div className="agent_dashboard_container__tickets_row" style={{ marginBottom: 8, paddingInline: '12px',}}>
                <TicketComponent
                  count={analyticsData?.totalTickets ?? '0'}
                  label={'Total Tickets'}
                  tooltipText={'The total number of tickets created including chatbot, agent, unassigned'}
                />
                <TicketComponent
                  count={analyticsData?.chatbotHandledTickets ?? '0'}
                  label={'Handled by Chatbot'}
                  tooltipText = {'The total number of tickets that are solely handled by the chatbot itself that doesn’t require human intervention'}
                />
                <TicketComponent
                  count={analyticsData?.agentHandledTickets ?? '0'}
                  label={'Handled by Agent'}
                  tooltipText= {'The total number of tickets that are handled by agent including directly assignment, Chatbot assignment, and self intervention'}
                />
                <TicketComponent
                  count={analyticsData?.unassignedTickets ?? '0'}
                  label={'Unassigned Tickets'}
                  tooltipText={'The total number of tickets that is neither handled by chatbot or any human agent due to inactivity'}
                />
              </div>
              </>
        )}
            </div>
 
                     <div
              className="shadow_small"
              style={{
                width: '100%',
                backgroundColor: '#fff',
                borderRadius: '12px',
                padding: '20px',
                marginBottom: '20px',
                marginTop: '12px',
              }}
            >
              {agentPerformanceLoading ? (
                <>
            <div
              className="d-flex flex-column justify-content-center align-items-center w-100"
              style={{ flex: 1 }}
            >
              <SpinnerLoader />
            </div>
          </>
              ) : (
                                <>
              <div className="agent_dashboard_container__header_row__right" style={{paddingInline: '12px',}}>
              <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '10px' }}>
                  Agent Performance
                </h2>
             <div className="agent_dashboard_container__header_row__right" style={{marginRight: -12, width: 'auto'}}>
            <Form.Select
              type="text"
              placeholder="time"
              className="btncustom dropdown"
              style={{ borderRadius: 8, fontSize: 16, fontWeight: 400, color: colors.greys01 }}
              value={performanceTimeFrame}
              onChange={(e) => {
                setPerformanceTimeFrame(e.target.value);
              }}
            >
              {analyticsTimeframes.map((item, index) => {
                return (
                  <option
                    style={{ marginTop: 4, marginBottom: 4, borderRadius: 8 }}
                    value={item.id}
                    key={item.id}
                  >
                    {item.label}
                  </option>
                );
              })}
            </Form.Select>
            <Form.Select
              type="text"
              placeholder="agent name"
              className="btncustom dropdown"
              style={{
                borderRadius: 8,
                fontSize: 16,
                fontWeight: 400,
                color: colors.greys01,
                marginInline: 16,
                width: 'auto',
              }}
              value={performanceAgentName}
        onChange={(e) => {
          setPerformanceAgentName(e.target.value);
        }}
            >
              <option
                style={{ marginTop: 4, marginBottom: 4, borderRadius: 8 }}
                key="blankchoice"
                hidden
                value
              >
                {'Agent name'}
              </option>
              <option
                style={{ marginTop: 4, marginBottom: 4, borderRadius: 8 }}
                value={'allAgent'}
                key={'allAgent'}
              >
                {'All Agents'}
              </option>
              {Object.keys(agentList)?.length > 0 &&
                Object.values(agentList).map((item, index) => {
                  return (
                    <option
                      style={{ marginTop: 4, marginBottom: 4, borderRadius: 8 }}
                      value={item._id}
                      key={item._id}
                    >
                      {item.name}
                    </option>
                  );
                })}
            </Form.Select>
            </div>  
          </div>
              <div className="agent_dashboard_container__tickets_row" style={{ marginBottom: 8, paddingInline: '12px',}}>
                <TicketComponent
                  count={performanceAnalyticsData?.agentHandled ?? '0'}
                  label={'Assigned to agent'}
                  tooltipText={'The total number of tickets that are handled by agent including directly assignment, Chatbot assignment, and self intervention'}
                />
                <TicketComponent
                  count={performanceAnalyticsData?.openTickets ?? '0'}
                  label={'Open Tickets'}
                  tooltipText={'The total number of tickets with an open status'}
                />
                <TicketComponent
                  count={performanceAnalyticsData?.pendingTickets ?? '0'}
                  label={'Pending Tickets'}
                  tooltipText={'The total number of tickets with a pending status'}

                />
                <TicketComponent
                  count={performanceAnalyticsData?.resolvedTickets ?? '0'}
                  label={'Resolved Tickets'}
                  tooltipText={'The total number of tickets with a resolved status'}
                />
              </div>
              </>
              )}
            </div>

            <div
              className="shadow_small"
              style={{
                width: '100%',
                backgroundColor: '#fff',
                borderRadius: '12px',
                padding: '20px',
                marginBottom: '20px',
                marginTop: '12px',
              }}
            >
              {responsePerformanceLoading ? (
                 <>
            <div
              className="d-flex flex-column justify-content-center align-items-center w-100"
              style={{ flex: 1 }}
            >
              <SpinnerLoader />
            </div>
          </>
              ) : (

             <>
              <div className="agent_dashboard_container__header_row__right" style={{paddingInline: '12px',}}>

                <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '10px' }}>
                  Response Performance
                </h2>
                   <div className="agent_dashboard_container__header_row__right" style={{ marginRight: -12, width: 'auto' }}>

                  <Form.Select
                    type="text"
                    placeholder="time"
                    className="btncustom dropdown"
                    style={{ borderRadius: 8, fontSize: 16, fontWeight: 400, color: colors.greys01 }}
                    value={responsePerformanceTimeFrame}
                    onChange={(e) => {
                      setResponsePerformanceTimeFrame(e.target.value);
                    }}
                  >
                    {analyticsTimeframes.map((item, index) => {
                      return (
                        <option
                          style={{ marginTop: 4, marginBottom: 4, borderRadius: 8 }}
                          value={item.id}
                          key={item.id}
                        >
                          {item.label}
                        </option>
                      );
                    })}
                  </Form.Select>
                   <Form.Select
              type="text"
              placeholder="agent name"
              className="btncustom dropdown"
              style={{
                borderRadius: 8,
                fontSize: 16,
                fontWeight: 400,
                color: colors.greys01,
                marginInline: 16,
                width: 'auto',
              }}
              value={responsePerformanceAgentName}
        onChange={(e) => {
          setresponsePerformanceAgentName(e.target.value);
        }}
            >
              <option
                style={{ marginTop: 4, marginBottom: 4, borderRadius: 8 }}
                key="blankchoice"
                hidden
                value
              >
                {'Agent name'}
              </option>
              <option
                style={{ marginTop: 4, marginBottom: 4, borderRadius: 8 }}
                value={'allAgent'}
                key={'allAgent'}
              >
                {'All Agents'}
              </option>
              {Object.keys(agentList)?.length > 0 &&
                Object.values(agentList).map((item, index) => {
                  return (
                    <option
                      style={{ marginTop: 4, marginBottom: 4, borderRadius: 8 }}
                      value={item._id}
                      key={item._id}
                    >
                      {item.name}
                    </option>
                  );
                })}
            </Form.Select>
                </div>
              </div>
            <div className="agent_dashboard_container__tickets_row" style={{ marginBottom: 8, paddingInline: '12px',}}>
              <TicketComponent
                count={responsePerformance?.avgFrt ?? '0'}
                label={'Avg First Response Time'}
                totalTickets= {'It’s an average of first response time for all the agents or a selected agent in a selected period of time'}
                tooltipText={' It’s an average of first response time for all the agents or a selected agent in a selected period of time'}
              />
              <TicketComponent
                count={responsePerformance?.avgResponseTime ?? '0'}
                label={'Avg Response Time'}
                tooltipText={'It’s the average of response time for every incoming message for an agent or all agents in a selected period of time'}
              />
              <TicketComponent
                count={responsePerformance?.avgResolutionTime ?? '0'}
                label={'Avg Resolution Time'}
                tooltipText={'It’s the average resolution time for each ticket  for an agent or all agents in a selected period of time'}
              />
              <TicketComponent
                count={responsePerformance?.frtBreachedCount ?? '0'}
                label={'FRT Exceeded Tickets'}
                tooltipText={'The number of tickets whose FRT exceeded for all agents or a selected agent in a selected period'}
              />
            </div>
            </>
              )}            
            </div>
                    
            {/* <div className="agent_dashboard_container__response_row"> */}
              <GraphComponent
                graphTimeframe={graphTimeframe}
                setGraphTimeframe={setGraphTimeframe}
                graphData={graphData}
                graphIsLoading={graphIsLoading}
                fromAgentDashboard = {true}
                agentList  =  {agentList}
                setgraphAgentName = {setgraphAgentName}
                graphAgentName = {graphAgentName}
              />
            {/* </div> */}
         
      </div>
    </>
  );
};

export default AgentAnalytics;